<template>
  <div id="pageUbicacion" @click="handleClickOutside">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card class="location-card elevation-2">
            <!-- Header mejorado -->
            <v-toolbar color="primary" dark flat>
              <v-icon class="mr-2">mdi-map-marker</v-icon>
              <v-toolbar-title v-if="!$vuetify.breakpoint.mdAndDown">Ubicaciones</v-toolbar-title>
              <v-spacer></v-spacer>

              <!-- Búsqueda para escritorio -->
              <v-col cols="3" class="mr-3" v-if="!$vuetify.breakpoint.mdAndDown">
                <v-text-field v-model="filter.search" label="Buscar ubicación..." prepend-inner-icon="mdi-magnify"
                  hide-details clearable rounded single-line filled dense dark @input="applyFilter"></v-text-field>
              </v-col>

              <!-- Búsqueda para móvil -->
              <v-tooltip top v-if="$vuetify.breakpoint.mdAndDown && !showSearch">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click.stop="toggleSearch">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Buscar</span>
              </v-tooltip>

              <v-col cols="12" v-if="showSearch && $vuetify.breakpoint.mdAndDown">
                <v-text-field ref="searchInput" v-model="filter.search" label="Buscar ubicación..."
                  prepend-inner-icon="mdi-magnify" hide-details clearable rounded single-line filled dense dark
                  class="search-input-mobile" @click.stop @input="applyFilter"></v-text-field>
              </v-col>

              <!-- Menú de filtros mejorado -->
              <filter-menu title="Filtrar ubicaciones" :current-filter="currentFilter" @canceled="rollbackFilter()"
                @filtered="commitFilter()">
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="filter.name" label="Nombre" clearable outlined dense hide-details="auto"
                      class="mb-4" prepend-inner-icon="mdi-office-building"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field v-model="filter.address" label="Dirección" outlined clearable dense
                      hide-details="auto" class="mb-4" prepend-inner-icon="mdi-map-marker"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field v-model="filter.city" label="Ciudad" outlined clearable dense hide-details="auto"
                      class="mb-4" prepend-inner-icon="mdi-city"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-select v-model="filter.state" :items="provincias" item-text="name" item-value="name"
                      label="Provincia" clearable outlined dense hide-details="auto" class="mb-4"
                      prepend-inner-icon="mdi-home-city"></v-select>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field v-model="filter.zip" label="Código Postal" clearable outlined dense
                      hide-details="auto" class="mb-4" prepend-inner-icon="mdi-mailbox"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field v-model="filter.phone" label="Teléfono" clearable outlined dense hide-details="auto"
                      class="mb-4" prepend-inner-icon="mdi-phone"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field v-model="filter.email" label="Correo Electrónico" clearable outlined dense
                      hide-details="auto" prepend-inner-icon="mdi-email"></v-text-field>
                  </v-col>

                  <!-- Campo de filtro por dealer (solo para colaboradores) -->
                  <v-col v-if="$store.getters.HAS_ROLE(['colaborator']) || this.hasDealersAsociados" cols="12" sm="6">
                    <v-select 
                      v-model="filter.dealer_id" 
                      :items="accessibleDealers" 
                      :loading="loadingAccessibleDealers"
                      item-value="id" 
                      item-text="name" 
                      label="Dealer" 
                      clearable 
                      outlined 
                      dense 
                      hide-details="auto" 
                      class="mb-4"
                      prepend-inner-icon="mdi-store"
                    >
                      <template v-slot:selection="{ item }">
                        <v-icon left small :color="item.is_own ? 'primary' : 'grey'">
                          {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                        </v-icon>
                        {{ item.name }}
                      </template>
                      <template v-slot:item="{ item }">
                        <v-icon left :color="item.is_own ? 'primary' : 'grey'">
                          {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                        </v-icon>
                        <span>{{ item.name }}</span>
                        <v-chip v-if="item.is_own" x-small class="ml-2" color="primary">Propio</v-chip>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </filter-menu>

              <!-- Botón agregar ubicación -->
              <v-tooltip top v-if="canCreateLocation">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="showUbicacionForm(null)" class="mr-2" color="white">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Agregar Ubicación</span>
              </v-tooltip>

              <!-- Botón refrescar -->
              <v-tooltip top v-if="canCreateLocation">
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="refreshDataTable" v-on="on" class="mr-2" color="white" :disabled="loadingItems">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar lista</span>
              </v-tooltip>

              <!-- Botón para cambiar vista (como en Vehículos) -->
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" color="white">
                    <v-icon>{{ viewMode === 'table' ? 'mdi-view-grid' : 'mdi-table' }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ viewMode === 'table' ? 'Vista de tarjetas' : 'Vista de tabla' }}</span>
              </v-tooltip> -->

              <!-- Formulario modal -->
              <ubicacion-form v-if="visibleForm" v-model="editItem" @save="updateDataTable"
                @cancel="visibleForm = false"></ubicacion-form>
            </v-toolbar>

            <!-- Selector de vista de tarjetas o tabla -->
            <v-card-actions class="px-4 py-2">
              <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2">
                {{ totalItems }} ubicaciones encontradas
              </div>
              <v-spacer></v-spacer>
              <v-btn-toggle v-model="viewMode" mandatory dense color="primary">
                <v-btn value="cards" small>
                  <v-icon small>mdi-view-grid-outline</v-icon>
                  Tarjetas
                </v-btn>
                <v-btn value="table" small>
                  <v-icon small>mdi-table</v-icon>
                  Tabla
                </v-btn>
              </v-btn-toggle>
            </v-card-actions>

            <!-- Vista de tarjetas -->
            <v-card-text v-if="viewMode === 'cards'" class="pa-3">
              <!-- Estado de carga -->
              <v-row v-if="loadingItems">
                <v-col cols="12" sm="6" md="4" lg="3" v-for="n in 8" :key="`skeleton-${n}`">
                  <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                </v-col>
              </v-row>
              
              <!-- Lista de ubicaciones en tarjetas -->
              <v-row v-else-if="LOCATIONS.length">
                <v-col cols="12" sm="6" md="4" lg="3" v-for="location in LOCATIONS" :key="location.id">
                  <v-card class="location-card-item h-100" outlined hover @click="viewLocationDetails(location)">
                    <v-card-text class="pa-4">
                      <!-- Icono y nombre -->
                      <div class="d-flex mb-3">
                        <v-avatar size="56" color="primary lighten-4" class="mr-3">
                          <v-icon size="32" color="primary">mdi-map-marker</v-icon>
                        </v-avatar>

                        <div>
                          <div class="subtitle-1 font-weight-bold mb-1">
                            {{ location.name }}
                            <v-chip v-if="isShared(location)" x-small color="deep-purple" dark class="ml-1"
                              :title="sharedWith(location)">Compartida</v-chip>
                          </div>
                          <div class="caption grey--text text--darken-1">
                            {{ location.city }}, {{ location.state }}
                          </div>
                        </div>
                      </div>

                      <!-- Información básica -->
                      <v-list dense class="pa-0 transparent">
                        <v-list-item class="px-0">
                          <v-list-item-icon class="mr-2">
                            <v-icon small color="grey darken-1">mdi-map-marker</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              {{ location.address }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0">
                          <v-list-item-icon class="mr-2">
                            <v-icon small color="grey darken-1">mdi-mailbox</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle>CP: {{ location.zip || 'No disponible' }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0">
                          <v-list-item-icon class="mr-2">
                            <v-icon small color="grey darken-1">mdi-phone</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle>{{ location.phone || 'No disponible' }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0">
                          <v-list-item-icon class="mr-2">
                            <v-icon small color="grey darken-1">mdi-email</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle class="text-truncate">{{ location.email || 'No disponible'
                              }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>

                        <!-- Dealer info (solo para colaboradores) -->
                        <v-list-item v-if="$store.getters.HAS_ROLE(['colaborator']) && (location.dealer || location.dealership)" class="px-0">
                          <v-list-item-icon class="mr-2">
                            <v-icon small :color="((location.dealer && location.dealer.is_colaborador) || (location.dealership && location.dealership.is_own)) ? 'primary' : 'grey'">
                              {{ ((location.dealer && location.dealer.is_colaborador) || (location.dealership && location.dealership.is_own)) ? 'mdi-home' : 'mdi-store' }}
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle>{{ (location.dealer && location.dealer.name) || (location.dealership && location.dealership.name) }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>

                    <v-divider></v-divider>

                    <!-- Acciones de tarjeta -->
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-tooltip top  v-if="canEditLocation">
                        <template v-slot:activator="{ on }">
                          <v-btn icon small color="primary" @click.stop="showUbicacionForm(location)" v-on="on">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon small color="info"
                            :to="{ name: 'UbicacionDetail', params: { ubicacion_id: location.id } }" v-on="on"
                            @click.stop>
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver detalles</span>
                      </v-tooltip>

                      <v-tooltip top v-if="canDeleteLocation">
                        <template v-slot:activator="{ on }">
                          <v-btn icon small color="red" @click.stop="confirmDeleteLocation(location)" v-on="on">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Sin resultados -->
              <v-row v-else>
                <v-col cols="12" class="text-center pa-6">
                  <h3 class="text-h5 grey--text text--darken-1 mb-2">No se encontraron ubicaciones</h3>
                  <p class="subtitle-1 grey--text mb-4">
                    Intenta con otros filtros o agrega una nueva ubicación
                  </p>
                  <v-btn color="primary" outlined @click="showUbicacionForm(null)" v-if="canCreateLocation">
                    <v-icon left>mdi-plus</v-icon>
                    Agregar ubicación
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Paginación en vista de tarjetas -->
              <div class="text-center pt-4" v-if="!loadingItems && LOCATIONS.length > 0">
                <v-row>
                  <v-col cols="12" class="d-flex justify-center align-center flex-wrap pa-2">
                    <div class="text-center d-flex align-center mr-4">
                      <span class="text-body-2 grey--text text--darken-1">Filas por página:</span>
                      <v-select v-model="pagination.itemsPerPage" :items="footer.itemsPerPageOptions" dense outlined
                        hide-details class="ml-2" style="width: 80px;" @change="onItemsPerPageChange"></v-select>
                    </div>

                    <v-pagination v-model="pagination.page" :length="Math.ceil(totalItems / pagination.itemsPerPage)"
                      :total-visible="7" circle @input="onPageChange"></v-pagination>

                    <span class="text-body-2 grey--text text--darken-1 ml-4">
                      {{ paginationText }}
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <!-- Vista de tabla -->
            <v-card-text v-else class="pa-0">
              <v-data-table :headers="dynamicHeaders" :items="LOCATIONS" :options.sync="pagination" :loading="loadingItems"
                :footer-props="footer" :key="tableId" item-key="id" class="elevation-0" multi-sort
                @click:row="viewLocationDetails" :server-items-length="totalItems">
                <!-- Nombre con ícono -->
                <template v-slot:item.name="{ item }">
                  <div class="d-flex align-center">
                    <v-avatar size="32" color="primary lighten-4" class="mr-2">
                      <v-icon size="18" color="primary">mdi-map-marker</v-icon>
                    </v-avatar>
                    <span class="font-weight-medium">{{ item.name }}</span>
                    <v-chip v-if="isShared(item)" x-small color="deep-purple" dark class="ml-2"
                      :title="sharedWith(item)">Compartida</v-chip>
                  </div>
                </template>

                <!-- Dirección completa -->
                <template v-slot:item.address="{ item }">
                  <div class="caption">
                    {{ item.address }}
                    <div class="mt-1">{{ item.city }}, {{ item.state }} {{ item.zip }}</div>
                  </div>
                </template>

                <!-- Teléfono con ícono -->
                <template v-slot:item.phone="{ item }">
                  <div class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-1">mdi-phone</v-icon>
                    <span>{{ item.phone || 'No disponible' }}</span>
                  </div>
                </template>

                <!-- Email con ícono -->
                <template v-slot:item.email="{ item }">
                  <div class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-1">mdi-email</v-icon>
                    <span>{{ item.email || 'No disponible' }}</span>
                  </div>
                </template>

                <!-- Dealer (solo para colaboradores) -->
                <template v-slot:item.dealer="{ item }">
                  <div v-if="item.dealer || item.dealership" class="d-flex align-center">
                    <v-avatar size="24" class="mr-2">
                      <img v-if="(item.dealer && item.dealer.imageUrl && item.dealer.imageUrl.url) || (item.dealership && item.dealership.imageUrl && item.dealership.imageUrl.url)" 
                           :src="(item.dealer && item.dealer.imageUrl && item.dealer.imageUrl.url) || (item.dealership && item.dealership.imageUrl && item.dealership.imageUrl.url)" 
                           alt="Logo dealer">
                      <v-icon v-else size="16" :color="((item.dealer && item.dealer.is_colaborador) || (item.dealership && item.dealership.is_own)) ? 'primary' : 'grey'">
                        {{ ((item.dealer && item.dealer.is_colaborador) || (item.dealership && item.dealership.is_own)) ? 'mdi-home' : 'mdi-store' }}
                      </v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-medium">{{ (item.dealer && item.dealer.name) || (item.dealership && item.dealership.name) }}</div>
                      <div class="caption grey--text text--darken-1">{{ (item.dealer && item.dealer.city) || (item.dealership && item.dealership.city) }}</div>
                    </div>
                  </div>
                  <div v-else class="grey--text">N/A</div>
                </template>

                <!-- Columna de acciones -->
                <template v-slot:item.action="{ item }">
                  <div class="d-inline-flex action-buttons">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }"  v-if="canEditLocation">
                        <v-btn icon small color="primary" @click.stop="showUbicacionForm(item)" v-on="on">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon small color="info"
                          :to="{ name: 'UbicacionDetail', params: { ubicacion_id: item.id } }" v-on="on" @click.stop>
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalles</span>
                    </v-tooltip>

                    <v-tooltip top  v-if="canDeleteLocation">
                      <template v-slot:activator="{ on }">
                        <v-btn icon small color="red" @click.stop="confirmDeleteLocation(item)" v-on="on">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </div>
                </template>

                <!-- Sin resultados -->
                <template v-slot:no-data>
                  <div class="text-center pa-6">
                    <h3 class="text-h5 grey--text text--darken-1 mb-2">No se encontraron ubicaciones</h3>
                    <p class="subtitle-1 grey--text mb-4">
                      Intenta con otros filtros o agrega una nueva ubicación
                    </p>
                    <v-btn color="primary" outlined @click="showUbicacionForm(null)" v-if="canCreateLocation">
                      <v-icon left>mdi-plus</v-icon>
                      Agregar ubicación
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Diálogo de confirmación mejorado -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline error--text">Confirmar eliminación</v-card-title>

        <v-card-text class="py-4">
          <v-row>
            <v-col cols="auto" class="pr-0">
              <v-avatar color="error" size="48" class="mr-4">
                <v-icon dark>mdi-alert</v-icon>
              </v-avatar>
            </v-col>
            <v-col>
              <p class="mb-1">¿Estás seguro de que deseas eliminar esta ubicación?</p>
              <p class="subtitle-1 font-weight-medium">{{ selectedLocation.name }}</p>
              <p class="caption grey--text">{{ selectedLocation.address }}, {{ selectedLocation.city }}</p>
            </v-col>
          </v-row>
          <p class="caption mt-3 red--text">Esta acción no se puede deshacer.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="error" text @click="deleteLocation" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import FilterMenu from '../../components/FilterMenu'
import DealerService from '../../services/DealerService'
import ProvinceService from '../../services/ProvinceService'

const STATUS_DISABLED = 0
const STATUS_ENABLED = 1

export default {
  components: {
    FilterMenu,
    UbicacionForm: () => import(/* webpackPrefetch: true */ './UbicacionForm')
  },

  data: () => ({
    // Vista y carga
    loadingItems: true, // Iniciar en true para evitar mostrar "sin resultados" al inicio
    loadingDelete: false,
    totalItems: 0,
    tableId: 0,
    showSearch: false,
    
    // Formulario
    visibleForm: false,
    editItem: null,
    
    // Diálogo de eliminación
    dialogDelete: false,
    selectedLocation: {},
    
    // Dealers accesibles (para colaboradores)
    accessibleDealers: [],
    loadingAccessibleDealers: false,
    
    // Tabla
    headers: [
      { text: 'Nombre', value: 'name', sortable: true, width: '20%' },
      { text: 'Dirección', value: 'address', sortable: true, width: '20%' },
      { text: 'Teléfono', value: 'phone', sortable: false, width: '15%' },
      { text: 'Email', value: 'email', sortable: false, width: '15%' },
      { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '120px' }
    ],
    footer: {
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      itemsPerPageText: 'Ubicaciones por página:',
      pageText: '{0}-{1} de {2}'
    },
    // Filtro
    filter: {
      search: null,
      status: null,
      name: null,
      address: null,
      city: null,
      state: null,
      zip: null,
      phone: null,
      email: null,
      dealer_id: null
    },
    currentFilter: {
      search: null,
      status: null,
      name: null,
      address: null,
      city: null,
      state: null,
      zip: null,
      phone: null,
      email: null,
      dealer_id: null
    },
    // Opciones y validaciones
    provincias: [],
    estados: [
      { name: 'Habilitado', value: STATUS_ENABLED },
      { name: 'Deshabilitado', value: STATUS_DISABLED }
    ],
    validations: {
      isValid: true,
      name: [
        (v) => /^[a-zA-Z\s]+$/.test(v) || 'El nombre solo puede contener letras y espacios.'
      ],
      address: [
        (v) => /^[a-zA-Z0-9\s]+$/.test(v) || 'La dirección solo puede contener letras, números y espacios.'
      ],
      city: [
        (v) => /^[a-zA-Z\s]+$/.test(v) || 'La ciudad solo puede contener letras y espacios.'
      ],
      state: [
        (v) => /^[a-zA-Z\s]+$/.test(v) || 'El estado solo puede contener letras y espacios.'
      ],
      zip: [
        (v) => /^[0-9]+$/.test(v) || 'El código postal solo puede contener números.'
      ],
      phone: [
        (v) => /^[0-9]+$/.test(v) || 'El teléfono solo puede contener números.'
      ],
      email: [
        (v) => /.+@.+\..+/.test(v) || 'Debe ser un correo electrónico válido.'
      ]
    },
    errors: {
      name: [],
      address: [],
      city: [],
      state: [],
      zip: [],
      phone: [],
      email: []
    },
    manualViewMode: null
  }),

  computed: {
    ...mapGetters(['LOCATIONS', 'CURRENT_USER_ROLES', 'CURRENT_USER', 'HAS_PERMISSION']),
    
    viewMode: {
      get() {
        // Si el usuario cambió manualmente la vista, usar esa
        if (this.manualViewMode) {
          return this.manualViewMode
        }
        // Detectar dispositivo y retornar vista por defecto
        if (this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndUp) {
          return 'table'
        }
        return 'cards'
      },
      set(value) {
        // Permitir cambio manual de vista
        this.manualViewMode = value
      }
    },
    
    hasDealersAsociados() {
    // Devuelve true si el usuario tiene dealers asociados
    const user = this.$store.getters.CURRENT_USER
    
    return (
      (user && Array.isArray(user.dealers_asociados) && user.dealers_asociados.length > 0)
    )
  },
    
    // Headers dinámicos basados en el rol del usuario
    dynamicHeaders() {
      let headers = [
        { text: 'Nombre', value: 'name', sortable: true, width: '20%' },
        { text: 'Dirección', value: 'address', sortable: true, width: '20%' },
        { text: 'Teléfono', value: 'phone', sortable: false, width: '15%' },
        { text: 'Email', value: 'email', sortable: false, width: '15%' }
      ]
      
      // Agregar columna de dealer solo para colaboradores
      if (this.$store.getters.HAS_ROLE(['colaborator']) || this.hasDealersAsociados) {
        headers.push({
          text: 'Dealer',
          value: 'dealer',
          sortable: false,
          width: '20%'
        })
      }
      
      headers.push({
        text: 'Acciones',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '120px'
      })
      
      return headers
    },
    
    pagination: {
      get: function () {
        return this.$store.getters.LOCATIONS_PAG
      },
      set: function (value) {
        this.$store.commit('SET_LOCATIONS_PAG', value)
      }
    },
    paginationText () {
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage + 1
      const end = Math.min(start + this.pagination.itemsPerPage - 1, this.totalItems)
      return `${start}-${end} de ${this.totalItems}`
    },
    searchTerm () {
      return this.filter.search
    },
    canCreateLocation () {
      return this.HAS_PERMISSION('crear_ubicacion')
    },
    canEditLocation () {
      return this.HAS_PERMISSION('editar_ubicacion')
    },
    canDeleteLocation () {
      return this.HAS_PERMISSION('eliminar_ubicacion')
    }
  },

  methods: {
    loadData () {
      this.loadingItems = true
      
      // Preparar parámetros de filtro
      let filterParams = { ...this.filter }
      
      // Obtener el dealer del usuario actual
      const currentUser = this.$store.getters.CURRENT_USER
      const userDealerId = currentUser?.dealer?.id
      
      // Debug: verificar qué se está enviando
      console.log('loadData - CURRENT_USER:', currentUser)
      console.log('loadData - userDealerId:', userDealerId)
      console.log('loadData - filter.dealer_id:', this.filter.dealer_id)
      
      // Si el usuario tiene un dealer asociado (colaborador propio), usar ese filtro
      if (userDealerId) {
        filterParams.colaborador_dealer_filter = userDealerId
        console.log('Aplicando filtro de dealer del usuario:', userDealerId)
      } else if (this.filter.dealer_id) {
        // Si hay un dealer seleccionado manualmente en el filtro, usarlo
        filterParams.colaborador_dealer_filter = this.filter.dealer_id
        console.log('Aplicando filtro de dealer manual:', this.filter.dealer_id)
      }
      
      // Eliminar dealer_id ya que usamos colaborador_dealer_filter
      delete filterParams.dealer_id
      
      console.log('filterParams finales:', filterParams)
      
      this.$store.dispatch('LOAD_LOCATIONS', filterParams)
        .then(result => {
          this.totalItems = result
          // Debug: verificar si las ubicaciones incluyen información del dealer
          if (this.LOCATIONS.length > 0) {
            console.log('Primera ubicación:', this.LOCATIONS[0])
            console.log('¿Tiene dealer?', this.LOCATIONS[0].dealer || this.LOCATIONS[0].dealership)
          }
          // Asegurarse de que la página actual es válida
          const maxPage = Math.ceil(result / this.pagination.itemsPerPage)
          if (this.pagination.page > maxPage && maxPage > 0) {
            this.pagination.page = maxPage
          }
          this.loadingItems = false
        })
        .catch(error => {
          console.error('Error al cargar ubicaciones:', error)
          this.$toast.error('Error al cargar las ubicaciones')
        })
        .finally(() => {
          this.loadingItems = false
        })
    },
    
    async loadAccessibleDealers () {
      // if (!this.$store.getters.HAS_ROLE(['colaborator'])) {
      //   return // Solo cargar para colaboradores
      // }

      try {
        this.loadingAccessibleDealers = true
        const response = await DealerService.getMyAccessibleDealers()
        
        // Verificar la estructura de la respuesta
        let dealersArray = []
        if (response.data && response.data.data && Array.isArray(response.data.data.data)) {
          dealersArray = response.data.data.data
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          dealersArray = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          dealersArray = response.data
        }
        
        this.accessibleDealers = dealersArray
      } catch (error) {
        console.error('Error al cargar dealers accesibles:', error)
        this.$toast.error('Error al cargar la lista de dealers')
      } finally {
        this.loadingAccessibleDealers = false
      }
    },
    
    debouncedLoadData: _.debounce(function () {
      this.loadData()
    }, 500),
    updateDataTable ({ insert }) {
      this.visibleForm = false
      if (insert) {
        this.totalItems++
      }
      this.refreshDataTable()
      this.$toast.success(insert ? 'Ubicación creada con éxito' : 'Ubicación actualizada con éxito')
    },
    refreshDataTable () {
      this.tableId++
      this.loadData()
    },
    // Ubicación asignada a más de un dealer (compartida dentro del grupo)
    isShared (location) {
      return Array.isArray(location.dealers) && location.dealers.length > 1
    },
    sharedWith (location) {
      return 'Compartida con: ' + (location.dealers || []).map(d => d.name).join(', ')
    },
    confirmDeleteLocation (item) {
      this.selectedLocation = item
      this.dialogDelete = true
    },
    deleteLocation () {
      this.loadingDelete = true
      this.$store.dispatch('DELETE_LOCATION', this.selectedLocation)
        .then(() => {
          this.dialogDelete = false
          this.$toast.success('Ubicación eliminada con éxito')
          this.refreshDataTable()
        })
        .catch(error => {
          console.error('Error al eliminar ubicación:', error)
          // Mostrar mensaje de error específico del backend si está disponible
          const errorMsg = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'No se pudo eliminar la ubicación. Puede estar en uso.'
          this.$toast.error(errorMsg)
        })
        .finally(() => {
          this.loadingDelete = false
        })
    },

    // Filtros
    commitFilter () {
      for (let [key] of Object.entries(this.currentFilter)) {
        this.currentFilter[key] = this.filter[key]
      }
      this.loadData()
    },
    rollbackFilter () {
      for (let [key, value] of Object.entries(this.currentFilter)) {
        this.filter[key] = value
      }
    },
    applyFilter () {
      this.debouncedLoadData()
    },

    // Acciones
    showUbicacionForm (item) {
      this.editItem = item ? { ...item } : null
      this.visibleForm = true
    },
    viewLocationDetails (location) {
      this.$router.push({
        name: 'UbicacionDetail',
        params: { ubicacion_id: location.id }
      })
    },
    toggleSearch () {
      this.showSearch = !this.showSearch
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    },
    handleClickOutside (event) {
      const searchInput = this.$refs.searchInput
      if (searchInput && !searchInput.$el.contains(event.target)) {
        this.showSearch = false
      }
    },
    onPageChange (page) {
      // Actualizar la página en la paginación
      this.pagination.page = page
      // Forzar la carga de datos inmediatamente después del cambio de página
      this.loadData()
    },
    onItemsPerPageChange (perPage) {
      // Actualizar items por página en la paginación
      this.pagination.itemsPerPage = perPage
      // Asegurarse de volver a la primera página al cambiar elementos por página
      this.pagination.page = 1
      // Forzar la carga de datos
      this.loadData()
    }
  },
  watch: {
    pagination: {
      handler (newVal, oldVal) {
        // Verificar si realmente cambió algo importante que requiera recargar
        const relevantPropsChanged = ['page', 'itemsPerPage', 'sortBy', 'sortDesc'].some(
          prop => !_.isEqual(newVal[prop], oldVal?.[prop])
        )
        // Solo recargar si hay cambios relevantes y no estamos en medio de una carga
        if (relevantPropsChanged && !this.loadingItems && !this.isInitializing) {
          this.loadData()
        }
      },
      deep: true
    },
    searchTerm () {
      this.debouncedLoadData()
    },
    // Watcher simple para viewMode (solo para registro)
    viewMode (newVal, oldVal) {
      console.log(`Vista cambiada de ${oldVal} a ${newVal}`)
    },
    manualViewMode (newVal, oldVal) {
      // Incrementar tableId cuando cambiamos a vista de tabla para forzar re-renderizado
      if (newVal === 'table' && oldVal === 'cards') {
        this.$nextTick(() => {
          this.tableId++
          setTimeout(() => {}, 100)
        })
      }
    },
    // Watcher para detectar cambios en el usuario actual
    '$store.state.AuthStore.currentUser': {
      handler (newUser, oldUser) {
        // Solo recargar si cambió el dealer del usuario
        const oldDealerId = oldUser?.dealer?.id
        const newDealerId = newUser?.dealer?.id
        
        if (oldDealerId !== newDealerId && newDealerId) {
          console.log('Usuario cambió, recargando ubicaciones con nuevo dealer:', newDealerId)
          this.loadData()
        }
      },
      deep: true
    }
  },
  async mounted () {
    ProvinceService.getAll().then(list => { this.provincias = list }).catch(() => {})
    console.log('mounted - CURRENT_USER al momento de montaje:', this.$store.getters.CURRENT_USER)
    
    // Esperar a que el store esté listo
    await this.$nextTick()
    
    // Si el usuario existe pero no tiene dealer cargado, esperar a que se recargue
    const currentUser = this.$store.getters.CURRENT_USER
    if (currentUser && !currentUser.dealer) {
      console.log('Usuario sin dealer, esperando recarga de datos...')
      // Esperar un tiempo razonable para que se complete RELOAD_USER_DATA
      await new Promise(resolve => setTimeout(resolve, 500))
      console.log('CURRENT_USER después de espera:', this.$store.getters.CURRENT_USER)
    }
    
    // Cargar dealers accesibles primero
    await this.loadAccessibleDealers()
    
    // Esperar otro tick después de cargar dealers
    await this.$nextTick()
    
    console.log('mounted - CURRENT_USER antes de loadData:', this.$store.getters.CURRENT_USER)
    
    // Cargar datos
    this.loadData()
  }
}
</script>

<style scoped>
.location-card {
  border-radius: 8px;
  overflow: hidden;
}

.location-card-item {
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease;
  border-radius: 8px;
}

.location-card-item:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}

.action-buttons button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.action-buttons button:hover {
  opacity: 1;
}

.search-input-mobile {
  max-width: 200px;
}

.h-100 {
  height: 100%;
}

/* Animación para nuevos elementos */
@keyframes highlight {
  0% {
    background-color: rgba(var(--v-primary-base), 0.1);
  }
  100% {
    background-color: transparent;
  }
}

.new-item {
  animation: highlight 2s ease-in-out;
}
</style>
